const fetchOrders$ = 'orders/fetchOrders$';
const fetchOrdersStartPolling$ = 'orders/fetchOrdersStartPolling$';
const fetchOrdersStopPolling$ = 'orders/fetchOrdersStopPolling$';
const fetchMoreOrders$ = 'orders/fetchMoreOrders$';
const updateFilters$ = 'orders/updateFilters$';

const openOrder$ = 'orders/openOrder$';
const closeOrder$ = 'orders/closeOrder$';

const UPDATE_SHIPMENT = 'orders/UPDATE_SHIPMENT';

const RESET_DATA = 'orders/RESET_DATA';
const SET_DATA = 'orders/SET_DATA';
const ADD_DATA = 'orders/ADD_DATA';

const SET_FILTER = 'orders/SET_FILTER';

const SET_PAGE = 'orders/SET_PAGE';
const RESET_PAGE = 'orders/RESET_PAGE';

const SET_FETCHING = 'orders/SET_FETCHING';
const SET_SUBMITTING = 'orders/SET_SUBMITTING';

const searchByText$ = 'orders/searchByText$';
const SET_SEARCH_TEXT = 'orders/SET_SEARCH_TEXT';

const setUserFilter$ = 'orders/setUserFilter$';
const clearUserFilter$ = 'orders/clearUserFilter$';
const SET_USER = 'orders/SET_USER';
const CLEAR_USER = 'orders/CLEAR_USER';

const setDateFilter$ = 'orders/setDateFilter$';
const clearDateFilter$ = 'orders/clearDateFilter$';
const clearDatesFilter$ = 'orders/clearDatesFilter$';
const SET_DATE = 'orders/SET_DATE';
const CLEAR_DATE = 'orders/CLEAR_DATE';
const cancelOrder$ = 'orders/cancelOrder$';

export default {
  fetchOrders$,
  fetchOrdersStartPolling$,
  fetchOrdersStopPolling$,
  fetchMoreOrders$,
  updateFilters$,
  openOrder$,
  closeOrder$,
  UPDATE_SHIPMENT,
  RESET_DATA,
  SET_DATA,
  ADD_DATA,
  SET_FILTER,
  SET_PAGE,
  RESET_PAGE,
  SET_FETCHING,
  SET_SUBMITTING,
  searchByText$,

  SET_SEARCH_TEXT,

  setUserFilter$,
  clearUserFilter$,
  SET_USER,
  CLEAR_USER,

  setDateFilter$,
  clearDateFilter$,
  clearDatesFilter$,
  SET_DATE,
  CLEAR_DATE,
  cancelOrder$,
};
